document.addEventListener("DOMContentLoaded", function () {
  const tags = document.querySelectorAll("[data-tag]");
  const tagInputs = document.querySelectorAll("[data-tag-input]");

  tags.forEach((tag) => {
    const tagName = tag.dataset.tag;
    const tagCloseButton = tag.querySelector("[data-tag-close]");

    if (!tagCloseButton) {
      return;
    }

    tagCloseButton.addEventListener("click", function () {
      tag.style.display = "none";

      document
        .querySelectorAll(`[data-tag-input="${tagName}"]`)
        .forEach((tagInput) => {
          if (tagInput.tagName == "SELECT") {
            tagInput.selectedIndex = 0;
          }

          if (tagInput.tagName == "INPUT") {
            tagInput.value = "";
          }
        });
    });
  });

  tagInputs.forEach((tagInput) => {
    const tagName = tagInput.dataset.tagInput;
    const tag = document.querySelector(`[data-tag="${tagName}"]`);

    if (!tag) {
      return;
    }

    tagInput.addEventListener("change", function () {
      const value = tagInput.value;
      const tagPreview = tag.querySelector("[data-tag-preview]");

      if (tagInput.tagName == "SELECT") {
        if (tagInput.selectedIndex == 0) {
          tagPreview.innerText = "";
          tag.style.display = "none";
          return;
        }
        tagPreview.innerText = tagInput.options[tagInput.selectedIndex].text;
        tag.style.display = "flex";
      }

      if (tagInput.tagName == "INPUT") {
        tagPreview.innerText = value;

        if (value == "") {
          tag.style.display = "none";
          return;
        }
        tag.style.display = "flex";
      }
    });
  });
});
